import fp from 'lodash/fp'
import { combine, withContext, withCallback } from 'react-hooks-combine'
import queryString from 'query-string'
import { StoreContext } from 'store/context'
import { toaster } from 'utils/toast-wrapper'
import { extractJWTPayload } from 'utils/standard/jwt'
import { auth as authRoutes } from 'routes/route.map'

import { PASSWORD_CHANGED } from './constants'
import ConfirmPasswordComponent from './component'

export const ConfirmPassword = combine({
  transformPropsBefore: ({ history, location }) => {
    const { token } = queryString.parse(location.search)

    return {
      history,
      token,
      initialValues: {
        email: fp.prop('email', extractJWTPayload(token)),
      },
    }
  },

  hooks: [
    withContext('auth', StoreContext, ({ auth }) => auth),
    withCallback(
      'onSubmit',
      ({ auth }, { token, history }) =>
        async ({ email, password }) => {
          await auth.confirmPassword(token, email, password)
          toaster.info(PASSWORD_CHANGED)
          history.push(authRoutes.login())
        },
      []
    ),
  ],
})(ConfirmPasswordComponent)
